import { setUnauthorizedCallback } from "../api/client";
import { useAuthPatientStore } from "./authPatientStore";

export async function initAuthPatient() {
  setUnauthorizedCallback(() => {
    useAuthPatientStore.getState().clearAuth();
  });
  useAuthPatientStore.setState({ isLoading: true });
  await useAuthPatientStore.getState().initAuth();
}
